import React from "react";
import classes from "./styles.module.scss";

const CustomCheckbox = React.forwardRef(({ checked, disabled, onChange, label, name, showCheckboxFirst, style, lstyle }, ref) => {
    return (
        <div className={classes.checkboxWrapper}>
            <label className={classes.checkboxLabel}>
                {!showCheckboxFirst ? (
                    <>
                        <input
                            type="checkbox"
                            style={style}
                            className={classes.checkbox}
                            checked={checked}
                            disabled={disabled}
                            onChange={onChange}
                            ref={ref}
                            name={name}
                        />
                        <span style={lstyle}>{label}</span>
                    </>
                ) : (
                    <>
                        <span>{label}</span>
                        <input
                            type="checkbox"
                            className={classes.checkbox}
                            checked={checked}
                            disabled={disabled}
                            onChange={onChange}
                            ref={ref}
                            name={name}
                            style={style}
                        />
                    </>
                )}
            </label>
        </div>
    );
});

export default CustomCheckbox;
